// This file was automatically generated from print.patientVisitSummary.html.
// Please don't edit this file by hand.

goog.provide('el8.template.print.patientVisitSummary');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.print');
goog.require('el8.template.print.visitNote.twoCol');
goog.require('el8.template.print.visitNote.vitals');
goog.require('el8.template.ptdata.model.note');
goog.require('el8.template.util.format');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.patientVisitSummary.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="pageWrap pageBreak">');
  el8.template.print.header(opt_data, output);
  output.append('<p class="mt25 fr"><img src="', (opt_data.localFsPath) ? 'file://' + soy.$$escapeHtml(opt_data.localFsPath) + '/..' : '', '/static/images/logo_fax_300dpi.jpg', (! opt_data.localFsPath) ? '?v=20160729' : '', '" height="12" width="80"></p><h1 class="documentTitle">Visit Summary</h1>');
  el8.template.print.patientInfoNotes({patient: opt_data.patient, timeOfPhrase: 'visit', physicianName: opt_data.summary.prescribingPhysicianName, displayPatientAge: opt_data.summary.displayPatientAge}, output);
  output.append('<h3 class="reasonTitle">Date of Encounter: ', (soy.$$escapeHtml(opt_data.summary.documentDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.summary.documentDate)) : ''), '</h3>');
  if (opt_data.summary.hasVitals) {
    output.append('<h2 class="sectionTitle">Vitals</h2>');
    el8.template.print.visitNote.vitals.content(soy.$$augmentData(opt_data.summary.vitals, {hasVitals: opt_data.summary.hasVitals}), output);
  }
  if (opt_data.summary.bullets.test.length || opt_data.summary.ownedDocuments.orders.length) {
    output.append('<h2 class="sectionTitle">Tests To Do</h2><ul class="list">');
    var tList16060 = opt_data.summary.ownedDocuments.orders;
    var tListLen16060 = tList16060.length;
    for (var tIndex16060 = 0; tIndex16060 < tListLen16060; tIndex16060++) {
      var tData16060 = tList16060[tIndex16060];
      output.append('<li class="preserve itemBullet">');
      el8.template.util.format.apply({text: tData16060.patientSummary, formatting: tData16060.patientSummaryFormatting}, output);
      output.append('</li>');
    }
    var tList16067 = opt_data.summary.bullets.test;
    var tListLen16067 = tList16067.length;
    for (var tIndex16067 = 0; tIndex16067 < tListLen16067; tIndex16067++) {
      var tData16067 = tList16067[tIndex16067];
      output.append('<li class="preserve itemBullet">', soy.$$escapeHtml(tData16067.text), '</li>');
    }
    output.append('</ul>');
  }
  if (opt_data.summary.ownedDocuments.newRx.length || opt_data.summary.ownedDocuments.refillRx.length || opt_data.summary.ownedDocuments.changeRx.length || opt_data.summary.ownedDocuments.dcRx.length || opt_data.summary.ownedDocuments.referrals.length || opt_data.summary.bullets.tx.length || opt_data.summary.bullets.procedure.length) {
    output.append('<h2 class="sectionTitle">Treatments</h2>');
    if (opt_data.summary.ownedDocuments.newRx.length) {
      output.append('<h4>New Prescriptions</h4><ul class="list">');
      var tList16079 = opt_data.summary.ownedDocuments.newRx;
      var tListLen16079 = tList16079.length;
      for (var tIndex16079 = 0; tIndex16079 < tListLen16079; tIndex16079++) {
        var tData16079 = tList16079[tIndex16079];
        output.append('<li class="preserve itemBullet">');
        el8.template.util.format.apply({text: tData16079.patientSummary, formatting: tData16079.patientSummaryFormatting}, output);
        output.append('</li>');
      }
      output.append('</ul>');
    }
    if (opt_data.summary.ownedDocuments.refillRx.length) {
      output.append('<h4>Rx Refills</h4><ul class="list">');
      var tList16090 = opt_data.summary.ownedDocuments.refillRx;
      var tListLen16090 = tList16090.length;
      for (var tIndex16090 = 0; tIndex16090 < tListLen16090; tIndex16090++) {
        var tData16090 = tList16090[tIndex16090];
        output.append('<li class="preserve itemBullet">');
        el8.template.util.format.apply({text: tData16090.patientSummary, formatting: tData16090.patientSummaryFormatting}, output);
        output.append('</li>');
      }
      output.append('</ul>');
    }
    if (opt_data.summary.ownedDocuments.changeRx.length || opt_data.summary.ownedDocuments.dcRx.length) {
      output.append('<h4>Rx Changes</h4><ul class="list">');
      var tList16101 = opt_data.summary.ownedDocuments.changeRx;
      var tListLen16101 = tList16101.length;
      for (var tIndex16101 = 0; tIndex16101 < tListLen16101; tIndex16101++) {
        var tData16101 = tList16101[tIndex16101];
        output.append('<li class="preserve itemBullet">');
        el8.template.util.format.apply({text: tData16101.patientSummary, formatting: tData16101.patientSummaryFormatting}, output);
        output.append('</li>');
      }
      var tList16108 = opt_data.summary.ownedDocuments.dcRx;
      var tListLen16108 = tList16108.length;
      for (var tIndex16108 = 0; tIndex16108 < tListLen16108; tIndex16108++) {
        var tData16108 = tList16108[tIndex16108];
        output.append('<li class="preserve itemBullet">');
        el8.template.util.format.apply({text: tData16108.patientSummary, formatting: tData16108.patientSummaryFormatting}, output);
        output.append('</li>');
      }
      output.append('</ul>');
    }
    if (opt_data.summary.ownedDocuments.referrals.length) {
      output.append('<h4>Referrals</h4><ul class="list">');
      var tList16119 = opt_data.summary.ownedDocuments.referrals;
      var tListLen16119 = tList16119.length;
      for (var tIndex16119 = 0; tIndex16119 < tListLen16119; tIndex16119++) {
        var tData16119 = tList16119[tIndex16119];
        output.append('<li class="preserve itemBullet">');
        el8.template.util.format.apply({text: tData16119.patientSummary, formatting: tData16119.patientSummaryFormatting}, output);
        output.append('</li>');
      }
      output.append('</ul>');
    }
    if (opt_data.summary.bullets.procedure.length) {
      output.append('<h4>Procedures</h4><ul class="list">');
      var tList16130 = opt_data.summary.bullets.procedure;
      var tListLen16130 = tList16130.length;
      for (var tIndex16130 = 0; tIndex16130 < tListLen16130; tIndex16130++) {
        var tData16130 = tList16130[tIndex16130];
        output.append('<li class="preserve itemBullet">', soy.$$escapeHtml(tData16130.text), '</li>');
      }
      output.append('</ul>');
    }
    if (opt_data.summary.bullets.tx.length) {
      output.append('<h4>Other Treatments</h4><ul class="list">');
      var tList16139 = opt_data.summary.bullets.tx;
      var tListLen16139 = tList16139.length;
      for (var tIndex16139 = 0; tIndex16139 < tListLen16139; tIndex16139++) {
        var tData16139 = tList16139[tIndex16139];
        output.append('<li class="preserve itemBullet">', soy.$$escapeHtml(tData16139.text), '</li>');
      }
      output.append('</ul>');
    }
  }
  if (opt_data.summary.bullets.instr.length) {
    output.append('<h2 class="sectionTitle">Other Instructions</h2><ul class="list">');
    var tList16148 = opt_data.summary.bullets.instr;
    var tListLen16148 = tList16148.length;
    for (var tIndex16148 = 0; tIndex16148 < tListLen16148; tIndex16148++) {
      var tData16148 = tList16148[tIndex16148];
      output.append('<li class="preserve fieldSavedBullet">', soy.$$escapeHtml(tData16148.text), '</li>');
      el8.template.print.visitNote.twoCol.childrenList({item: tData16148}, output);
    }
    output.append('</ul>');
  }
  output.append('<h2 class="sectionTitle">Follow-up</h2><ul class="list"><li class="preserve itemBullet">');
  if (opt_data.summary.bullets.followup.length) {
    var tList16159 = opt_data.summary.bullets.followup;
    var tListLen16159 = tList16159.length;
    for (var tIndex16159 = 0; tIndex16159 < tListLen16159; tIndex16159++) {
      var tData16159 = tList16159[tIndex16159];
      output.append(soy.$$escapeHtml(tData16159.text), (! (tIndex16159 == tListLen16159 - 1)) ? '; ' : '');
    }
  } else {
    output.append('See ', (opt_data.summary.prescribingPhysicianName) ? soy.$$escapeHtml(opt_data.summary.prescribingPhysicianName) : 'the Doctor', ' as needed.');
  }
  output.append('</li></ul>');
  if (opt_data.summary.bill) {
    output.append('<h2 class="sectionTitle">Billing Information</h2>');
    if (opt_data.summary.bill.cpts.length || opt_data.summary.bill.refNumber || opt_data.summary.bill.billingDate || opt_data.summary.bill.notes) {
      output.append('<table class="subSection">');
      if (opt_data.summary.bill.cpts.length || opt_data.summary.bill.refNumber || opt_data.summary.bill.billingDate) {
        output.append('<tr><td class="subSectionTitle">Bill:</td><td class="subSectionText"><ul class="list">');
        var cptList16183 = opt_data.summary.bill.cpts;
        var cptListLen16183 = cptList16183.length;
        for (var cptIndex16183 = 0; cptIndex16183 < cptListLen16183; cptIndex16183++) {
          var cptData16183 = cptList16183[cptIndex16183];
          output.append('<li class="itemBullet preserve">');
          el8.template.ptdata.model.note.billCptSummary(cptData16183, output);
          output.append('</li>');
        }
        output.append((opt_data.summary.bill.refNumber || opt_data.summary.bill.billingDate) ? '<li class="itemBullet preserve">' + ((opt_data.summary.bill.billingDate) ? 'Billed on ' + (soy.$$escapeHtml(opt_data.summary.bill.billingDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.summary.bill.billingDate)) : '') : 'Date unknown') + ' ' + ((opt_data.summary.bill.refNumber) ? '(#' + soy.$$escapeHtml(opt_data.summary.bill.refNumber) + ').' : '') + '</li>' : '', '</ul></td></tr>');
      }
      output.append((opt_data.summary.bill.notes) ? '<tr><td class="subSectionTitle">Note:</td><td class="subSectionText"><p class="preserve">' + soy.$$escapeHtml(opt_data.summary.bill.notes) + '</p></td></tr>' : '', '</table>');
    } else {
      output.append('No billing information.');
    }
  }
  output.append((opt_data.summary.includePassportNotice) ? '<p class="el8Italic mt20">You can access this info securely online. Ask your physician office for details.</p>' : '', '</div>');
  if (!opt_sb) return output.toString();
};
